// src/components/ui/HeroSection.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';

interface HeroSectionProps {
  title: string;
  subtitle: string;
  description: string;
  ctaText: string;
  ctaLink: string;
  backgroundImage: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  description,
  ctaText,
  ctaLink,
  backgroundImage,
}) => {
  return (
    <section className="relative">
      <div
        className="min-h-[70vh] bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'contrast(1.1) brightness(1.05)'
        }}
      >
        <div className="absolute inset-0 bg-luxdark/50"></div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 flex flex-col justify-center h-full py-16">
          <div className="max-w-3xl text-center mx-auto">
            <h3 className="text-luxgold font-light mb-2 text-lg md:text-xl uppercase tracking-wider">
              {subtitle}
            </h3>
            <h1 className="text-white text-3xl md:text-5xl font-semibold mb-6">{title}</h1>
            <div className="h-px w-24 bg-luxgold mx-auto mb-6"></div>
            <p className="text-white/90 mb-8 text-base md:text-lg">
              {description}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                asChild
                className="bg-luxgold hover:bg-luxgold/90 text-luxdark font-medium px-8 py-6 rounded-lg text-base w-full sm:w-auto transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-luxgold/20 hover:-translate-y-1"
              >
                <Link to={ctaLink}>
                  {ctaText}
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="bg-white/15 backdrop-blur-md border-white/80 text-white hover:bg-white hover:text-luxdark px-8 py-6 rounded-lg text-base w-full sm:w-auto transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-white/20 hover:-translate-y-1"
              >
                <a href="tel:031467272">
                  <Phone className="mr-2 w-5 h-5" />
                  031 467 272
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;